import { BaseService } from './base.service';

export class MemosService extends BaseService {
  static get resourceEndpoint() {
    return 'memos';
  }
}
